jQuery(document).ready(function ($) {
    function isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }
    var counted = false;
    if ($('.counter').length > 0) {
        $(window).on('scroll', function () {
            var $counter = $('.counter');
            if (isScrolledIntoView($counter) && !counted) {
            counted = true;

            $('.counter').each(function () {
                var show = '';
                var $this = $(this),
                    countTo = $this.attr('data-count');
                    show = $(this).attr('data-show');
            
                $({ countNum: $this.text() }).animate({
                countNum: countTo,
                },
                {
                duration: 2000,
                easing: 'swing',
                step: function () {
                    $this.text(Math.floor(this.countNum));
                },
                complete: function () {
                    $this.text(show);
                }
                });
            });
            }
        });
    }
  $('footer .has-dropdown .footer-block__heading').click(function (e) { 
    e.preventDefault();
    $(this).toggleClass('active');
  });
  
  function slider_mobile() {
    if($(window).width() <= 949){ 
      var swiper = new Swiper('.testimonials-slider', {
        slidesPerView: 1,
        spaceBetween:20,
        loop: true,
        centeredSlides: true,
        pagination: {
          el: ".testimonials-slider .swiper-pagination",
        },
        autoplay: {
          delay: 50000,
          disableOnInteraction: false,
        }
      });
      
    }
  }
//   $(document).ready(slider_mobile);
//   $(window).on('resize', function() {
//     slider_mobile();
//   });

   $(document).on('click', '[data-pagination-link]', function(e) {
    e.preventDefault();
    const $button = $(this);
    const nextUrl = $button.attr('href');

    $button.text("Laden...");
    $button.prop('disabled', true);

    $.get(nextUrl, function(response) {
        const $tempDiv = $('<div>').html(response);
        const newProductsHtml = $tempDiv.find('#product-grid').html();
        const $newButton = $tempDiv.find('[data-pagination-link]');
        
        $('ul#product-grid').append(newProductsHtml);
        $button.closest('.show_more_btn').remove(); // remove old button wrapper

        if ($newButton.length) {
            $('ul#product-grid').after($newButton.closest('.show_more_btn')); // add new button wrapper
        }
    }).fail(function() {
        console.error('Error loading more products.');
        $button.text("Try again");
        $button.prop('disabled', false);
    });
});

  
  $('.testimonials-down').click(function (e) { 
      e.preventDefault();
      $(this).hide();
      $('.testimonials-slider').toggleClass('testimonials-lm');
  });
  $('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.acc-content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.acc-content').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.acc-content').slideToggle();
      $(this).toggleClass('active');
    }
  });
  //initFlickityMobile
    function initFlickityMobile() {
        var $lists = $(".metaobject-list-versprechen,.swiper-wrapper-testimonials");
        var $lists_left = $(".collection-subcategories__list,.nt_strasse .multicolumn-list,.nt_versandkostenfrei .static-items,ul.article-passende-produkte__grid.grid.collection");
        var $lists_left_dots = $(".no_slider_custom ul,.st__full_slider ul");
        if ($(window).width() < 950) {
            $lists.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: true,
                        freeScroll: false,
                        wrapAround: false,
                        prevNextButtons: false,
                        autoPlay: 5000,
                        groupCells: false,
                        cellAlign: 'center'
                    });
                }
            });
            $lists_left.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: false,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 5000,
                        groupCells: false,
                        cellAlign: 'left'
                    });
                }
            });
            $lists_left_dots.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: true,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 5000,
                        groupCells: false,
                        cellAlign: 'left'
                    });
                }
            });
        } else {
            $lists.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
            $lists_left.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
            $lists_left_dots.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
        }
    }
    $(document).ready(initFlickityMobile);
    $(window).on('resize', initFlickityMobile);
});
